module.exports = __webpack_public_path__ + "img/banners_error.370307c8.webp";